// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1UXPd","subheader":"ReorderModal_subheader__1OWij","listWrap":"ReorderModal_listWrap__2fPx7"};